import { render, staticRenderFns } from "./DetailsNavBar.vue?vue&type=template&id=50286f52&scoped=true&"
import script from "./DetailsNavBar.vue?vue&type=script&lang=js&"
export * from "./DetailsNavBar.vue?vue&type=script&lang=js&"
import style0 from "./DetailsNavBar.vue?vue&type=style&index=0&id=50286f52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50286f52",
  null
  
)

export default component.exports